howspace.commentsTrait.oldMoveCommentHandlers = (() => {
    'use strict';

    const addOffsetToPosition = (position, sourceElement, targetElement) => {
        const offset = sourceElement.offset();
        const offsetFrom = targetElement.offset();
        const offsetTopDiff = offsetFrom.top - offset.top;
        const offsetLeftDiff = offsetFrom.left - offset.left;
        position.top += offsetTopDiff;
        position.left += offsetLeftDiff;
        return position;
    };

    const loadNewComment = (widget, widgetFrom, commentFrom, oldCommentWillBeRemoved, newCommentWillBeAdded, notification) => {

        const renderComment = (widget, newComment) => {
            if (real.events.isFromCurrentUser(notification)
                && !widget.data('has-user-commented')
                && !widget.data('user-can-see-comments-before-has-given-comment')) {
                widget.dataAndAttr('has-user-commented', true);
                if (!widget.data('is-moderation-in-use') || notification.object.comment.is_approved) {
                    widget.dataAndAttr('has-user-commented', true);
                }
            }

            const comments = widget.find('.comments .howspace-lister-cards:first');
            const lister = widget.find('.comments.howspace-lister:first');

            if (widget.data('latest-comment-at-top')) {
                comments.prepend(newComment);
            } else {
                comments.append(newComment);
            }

            howspace.components.init(newComment);
            howspace.whatsNew.decorateComment(newComment);
            howspace.commentsTrait.clampCommentText(widget, newComment);

            // Increase number of comments attr.
            howspace.commentsTrait.updateNumberOfComments(widget, 1);
            howspace.commentsTrait.commentsViewHandler.observeViews(widget);

            // Remove any style attributes from the lister no items element.
            lister.find('.howspace-lister-no-items').removeAttr('style');
            // Add the grid style to the lister cards element, this is needed for calculating the position of the new comment.
            comments.css({ display: 'grid' });

            let position = newComment.position();
            if (oldCommentWillBeRemoved) {
                removeOldComment(widget, widgetFrom, commentFrom, newCommentWillBeAdded, notification);
                position = addOffsetToPosition(position, newComment, commentFrom);
            }

            // Add clone of new comment.
            const cloneOfNewComment = newComment.clone();

            cloneOfNewComment.css({
                width: newComment.width(),
                height: newComment.height(),
                marginBottom: 0,
                position: 'absolute',
                top: position.top,
                left: position.left,
                opacity: 0,
                zIndex: 10
            });

            cloneOfNewComment.attr('id', cloneOfNewComment.attr('data-id') + '-move-animation-clone');
            newComment.before(cloneOfNewComment);

            // Animate the add comment clone.
            position = cloneOfNewComment.position();
            position = addOffsetToPosition(position, cloneOfNewComment, newComment);

            const newCommentAnimProps = {
                top: position.top,
                left: position.left,
                opacity: 1
            };
            howspace.animate(cloneOfNewComment, newCommentAnimProps, howspace.getAnimationDuration(widget, '--howspace-animation-700'),
                () => {
                    cloneOfNewComment.remove();
                }
            );

            // Animate the added comment.
            const animHeight = newComment.height();

            newComment.css({
                height: 0,
                opacity: 0
            });

            const animProps = {
                height: animHeight,
                opacity: 1
            };
            howspace.animate(newComment, animProps, howspace.getAnimationDuration(widget, '--howspace-animation-700'),
                () => {
                    newComment.removeAttr('style');
                }
            );
        }

        if (widget.find('.comment[data-id="' + notification.object.comment.id + '"]').length === 0) {
            renderComment(widget, $(notification.object.comment.html));
        }

        if (howspace.widgets.hasParallel(widget)) {
            real.ajax.html(howspace.commentsTrait.getCommentViewUrl(howspace.widgets.getParallel(widget), notification.object.comment.id), {
                success: (data) => {
                    renderComment(howspace.widgets.getParallel(widget), $(data));
                }
            });
        }
    };

    const removeOldComment = (widget, widgetFrom, commentFrom, newCommentWillBeAdded, notification) => {
        // Decrease number of comments attr.
        howspace.commentsTrait.updateNumberOfComments(widgetFrom, -1);

        if (newCommentWillBeAdded) {
            const cloneOfRemovedComment = commentFrom.clone();
            let position = commentFrom.position();

            cloneOfRemovedComment.css({
                width: commentFrom.width(),
                height: commentFrom.height(),
                marginBottom: 0,
                position: 'absolute',
                top: position.top,
                left: position.left,
                zIndex: 10
            });

            cloneOfRemovedComment.attr('id', cloneOfRemovedComment.attr('id') + '-move-animation-clone');
            commentFrom.closest('.comments .howspace-lister-cards').prepend(cloneOfRemovedComment);

            position = cloneOfRemovedComment.position();
            position = addOffsetToPosition(position, cloneOfRemovedComment, commentFrom);

            const oldCommentAnimProps = {
                top: position.top,
                left: position.left,
                opacity: 0
            };

            howspace.animate(cloneOfRemovedComment, oldCommentAnimProps, howspace.getAnimationDuration(widget, '--howspace-animation-700'),
                () => {
                    cloneOfRemovedComment.remove();
                }
            );
        }

        // Animate the removed comment.
        howspace.animate(commentFrom, 'slideUp', howspace.getAnimationDuration(widget, '--howspace-animation-700'), () => {
            commentFrom.remove();
        });

        if (howspace.widgets.hasParallel(widgetFrom)) {
            const parallelWidget = howspace.widgets.getParallel(widgetFrom);
            const commentWidget = parallelWidget.find('.comment[data-id="' + notification.object.comment_from.id + '"]');
            howspace.animate(commentWidget, 'slideUp', howspace.getAnimationDuration(parallelWidget, '--howspace-animation-700'), () => {
                commentWidget.remove();
            });
        }
    };

    const moveComment = (notification) => {
        const widget = $('#widget-' + notification.object.discussion.id);
        const widgetFrom = $('#widget-' + notification.object.discussion_from.id);
        const commentFrom = widgetFrom.find('.comment[data-id=' + notification.object.comment_from.id + ']');

        let newCommentWillBeAdded = widget.length > 0;
        let oldCommentWillBeRemoved = commentFrom.length > 0;

        // Check if moderation is in use.
        if (widget.data('is-moderation-in-use')
            && !notification.object.comment.is_approved
            && !widget.data('user-can-see-non-approved-comments')
            && notification.object.comment.user.id !== real.dom.$body.data('user-id')) {
            newCommentWillBeAdded = false;
        }

        // Check if is an own comment
        if (widget.data('user-can-see-only-own-comments')
            && notification.object.comment.user.id !== real.dom.$body.data('user-id')) {
            // User did not author this comment. Do not try to load from server.
            newCommentWillBeAdded = false;
        }

        if (widget.data('user-can-see-only-team-comments')
            && notification.object.comment.team
            && !real.dom.$body.data('team-ids').includes(notification.object.comment.team.id)) {
            // User's teams did not author this comment. Do not try to load from server.
            return;
        }

        if (widget.data('user-can-see-only-userlist-comments')) {
            let userlistFound = false;
            notification.object.comment.userlist.ids.forEach(function (userlistId) {
                if (real.dom.$body.data('userlist-ids').includes(userlistId)) {
                    userlistFound = true;
                }
            });
            if (!userlistFound) {
                // User's user lists did not author this comment. Do not try to load from server.
                return;
            }
        }

        if (newCommentWillBeAdded) {
            loadNewComment(widget, widgetFrom, commentFrom, oldCommentWillBeRemoved, newCommentWillBeAdded, notification);
        } else if (oldCommentWillBeRemoved) {
            removeOldComment(widget, widgetFrom, commentFrom, newCommentWillBeAdded, notification);
        }
    };

    return {
        moveComment: moveComment,
    };
})();
